import { gsap } from 'gsap';

import { Controller } from './Controller';

export class MediaPreview extends Controller {
  // preview(videoURL: string) {
  //   throw new Error('Method not implemented.');
  // }
  private imagePreviewContainer: HTMLElement | null;
  //private previewImage: HTMLElement | null;
  private videoElement: HTMLVideoElement | null = null;
  private videoControls: HTMLElement | null = null;
  private hideControlsTimeout: any;
  private isImagePreviewing = false;
  //private activeVideoElement: HTMLVideoElement | null = null;

  constructor() {
    super();

    // this.previewImage = document.getElementById('preview-image');
    this.imagePreviewContainer = this.elementsManager.elements.imagePreviewContainer as HTMLElement;
    this.videoControls = this.elementsManager.elements.videoControls as HTMLElement;
    this.initializeVideoControls();
  }
  public preview(src: string): void {
    this.isImagePreviewing = true;
    const videoContainer = document.getElementById('videoPreview');
    if (videoContainer) {
      const videoElement = videoContainer.querySelector('video');
      if (videoElement) {
        videoElement.pause();
        videoElement.currentTime = 0;
        videoContainer.innerHTML = '';
      }
    }

    // if (this.previewImage) {
    //   this.previewImage.style.opacity = '0';
    // }

    if (this.imagePreviewContainer) {
      this.imagePreviewContainer.innerHTML = '';
      this.imagePreviewContainer.innerHTML = `<img src="${src}" alt="Image Preview" class="preview-image">`;
      this.imagePreviewContainer.style.display = 'block';

      gsap.fromTo(
        this.imagePreviewContainer,
        { opacity: 0 },
        { opacity: 1, delay: 0.2, duration: 0.3, ease: 'power3.out' }
      );
    }
  }

  public clear(): void {
    this.isImagePreviewing = false;
    const videoContainer = document.getElementById('videoPreview');
    if (videoContainer) {
      this.videoElement = videoContainer.querySelector('video');
      if (this.videoElement) {
        this.videoElement.pause(); // pause the video playback
        this.videoElement.currentTime = 0; // reset its play time to the beginning
        videoContainer.innerHTML = ''; // clear the video preview
      }
    }

    if (this.imagePreviewContainer) {
      gsap.to(this.imagePreviewContainer.getElementsByTagName('img'), {
        opacity: 0,
        scale: 0.95,
        duration: 0.3,
        ease: 'power3.out',
        onComplete: () => {
          // if (this.imagePreviewContainer) this.imagePreviewContainer.innerHTML = '';
        },
      });
    }
  }
  private initializeVideoControls(): void {
    // Hide pause button initially
    if (this.elementsManager.elements.videoControlsPause) {
      //this.elementsManager.elements.videoControlsPause.style.display = 'none';
      this.hideVideoControls();
    }
    // Add event listener for video ended

    this.videoElement?.addEventListener('ended', () => {
      this.videoElement!.currentTime = 0;
      this.updateVideoControls();
    });

    // Add event listener for play button
    this.elementsManager.elements.videoControlsPlay?.addEventListener('click', () => {
      if (this.videoElement) {
        this.videoElement.play();

        this.updateVideoControls();
      }
    });

    // Add event listener for pause button
    this.elementsManager.elements.videoControlsPause?.addEventListener('click', () => {
      if (this.videoElement) {
        this.videoElement.pause();
        this.updateVideoControls();
      }
    });
  }
  //
  private updateVideoControls(): void {
    if (this.videoElement?.paused) {
      // Show play and hide pause
      if (this.elementsManager.elements.videoControlsPlay) {
        this.elementsManager.elements.videoControlsPlay.style.display = 'block';
      }
      if (this.elementsManager.elements.videoControlsPause) {
        this.elementsManager.elements.videoControlsPause.style.display = 'none';
      }
    } else {
      // Show pause and hide play
      if (this.elementsManager.elements.videoControlsPlay) {
        this.elementsManager.elements.videoControlsPlay.style.display = 'none';
      }
      if (this.elementsManager.elements.videoControlsPause) {
        this.elementsManager.elements.videoControlsPause.style.display = 'block';
      }
    }
  }
  //
  private showVideoControls(): void {
    gsap.to(
      [
        this.elementsManager.elements.videoControlsPlay,
        this.elementsManager.elements.videoControlsPause,
      ],
      {
        opacity: 1,

        duration: 0.3,
        ease: 'power2.out',
        overwrite: true,
      }
    );
  }

  private hideVideoControls(): void {
    gsap.to(
      [
        this.elementsManager.elements.videoControlsPlay,
        this.elementsManager.elements.videoControlsPause,
      ],
      {
        opacity: 0,
        duration: 0.3,
        ease: 'power2.out',
        overwrite: true,
      }
    );
  }
  public previewVideo(src: string): void {
    if (this.imagePreviewContainer) {
      this.imagePreviewContainer.innerHTML = '';
      gsap.to(this.imagePreviewContainer, { opacity: 0, scale: 1, duration: 0.3 });
    }

    this.videoElement = document.createElement('video');
    this.videoElement.classList.add('video-player');
    this.videoElement.src = src;
    this.videoElement.controls = false;
    this.videoElement.autoplay = true;

    // Initially set the video's opacity to 0
    // gsap.set(this.videoElement, { opacity: 0 });
    gsap.to(this.videoElement, {
      opacity: 1,
      duration: 0.3,
      ease: 'power2.out',
    });

    const videoContainer = document.getElementById('videoPreview');
    if (videoContainer) {
      videoContainer.innerHTML = ''; // Clear any previous video preview
      videoContainer.appendChild(this.videoElement);
      //this.videoElement.poster = 'https://via.placeholder.com/150';
    }

    // Add the event listener for when the video starts playing
    this.videoElement.addEventListener('play', () => {
      // Fade in the video once it starts playing
      gsap.to(this.videoElement, {
        opacity: 1,
        duration: 0.3,
        ease: 'power2.out',
      });

      setTimeout(() => {
        this.showVideoControls();
      }, 200); // Show controls after 1 second

      // Clear any existing timeout (in case video is paused and played again)
      if (this.hideControlsTimeout) {
        clearTimeout(this.hideControlsTimeout);
      }

      // Hide controls after 5 seconds (or any duration you want)
      this.hideControlsTimeout = setTimeout(() => {
        this.hideVideoControls();
      }, 1000);
    });

    // Show controls when hovering over the video
    // Show controls when hovering over the video
    this.videoControls?.addEventListener('mouseenter', () => {
      if (!this.isImagePreviewing) {
        this.showVideoControls();
      }
    });

    // Hide controls when the mouse leaves the video
    this.videoControls?.addEventListener('mouseleave', () => {
      if (!this.isImagePreviewing) {
        this.hideVideoControls();
      }
    });
    this.isImagePreviewing = false;
  }
}
